import { normalizeRole } from "../role-match";

/**
 * The `legal-your-executor` role choices (template-spec `legal.ts`, the `role` field) — the words stored in the cell
 * and shown on the classic page. `executor_access.executor_role` holds the same three as enum values
 * (`server/persons/pilot-map.ts` EXECUTOR_ROLE_LABELS).
 */
export const EXECUTOR_ROLE = {
  PRIMARY: "Primary",
  CO_EXECUTOR: "Co-executor",
  ALTERNATE: "Alternate",
} as const;

/**
 * s232 (BACKUP-NUDGE-1, D-232.13): a backup executor is a `legal-your-executor` row whose role is Alternate. Reads
 * either form — the cell's word ("Alternate") or the access row's enum value ("alternate"). Pure.
 */
export function isAlternateRole(role: string | null | undefined): boolean {
  return normalizeRole(role) === normalizeRole(EXECUTOR_ROLE.ALTERNATE);
}

/**
 * s232 (D-232.8) — "Does your will name a backup executor?" (board 1, the `exec` step's `bk` column), stored on
 * `clients.will_names_backup`. `null` = not answered yet.
 */
export const WILL_NAMES_BACKUP = ["yes", "no", "not_sure"] as const;
export type WillNamesBackup = (typeof WILL_NAMES_BACKUP)[number];
